<template>
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
  setup() {
    return {
      zhCN
    }
  }
})
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
